"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _cssVendor = _interopRequireDefault(require("css-vendor"));
var _reactDotdotdot = _interopRequireDefault(require("react-dotdotdot"));
var _styles = require("@material-ui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable security/detect-non-literal-fs-filename */
/*:: import { type ThemeType } from '../style/ThemeTypes';*/
/*:: type Props = {
  // It would be nice if `children: string | React.Element<typeof FormattedMessage>`
  // but `ProcessVersionList.js` and `SearchListItem.js` requires a `React.Node` type
  children: React.Node,
  clamp: number,
  className?: string
};*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    truncate: _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.truncate), theme.mixins.breakWord), {}, {
      display: 'inline-block',
      maxWidth: '100%',
      verticalAlign: 'top'
    }),
    lineClamp: function lineClamp(_ref /*:: */) {
      var clamp = _ref /*:: */.clamp;
      return _objectSpread(_objectSpread({}, theme.mixins.breakWord), {}, {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-box-orient': 'vertical',
        display: '-webkit-inline-box',
        '-webkit-line-clamp': clamp,
        maxWidth: '100%',
        verticalAlign: 'top'
      });
    },
    dotdotdot: _objectSpread(_objectSpread({}, theme.mixins.breakWord), {}, {
      display: 'inline-block',
      maxWidth: '100%',
      verticalAlign: 'top'
    })
  };
});
var Clamp = function Clamp(_ref2 /*:: */) {
  var children = _ref2 /*:: */.children,
    className = _ref2 /*:: */.className,
    clamp = _ref2 /*:: */.clamp;
  var classes = useStyles({
    clamp: clamp
  });
  var title = typeof children === 'string' ? children : undefined;

  // Use CSS solution if number of lines is less than 2.
  if (clamp < 2) {
    return /*#__PURE__*/React.createElement("span", {
      className: (0, _classnames.default)(classes.truncate, className),
      title: title
    }, children);
  }

  // Use CSS3 solution if supported.
  if (_cssVendor.default.supportedProperty('-webkit-line-clamp')) {
    return /*#__PURE__*/React.createElement("span", {
      className: (0, _classnames.default)(classes.lineClamp, className),
      title: title
    }, children);
  }

  // The number of lines displayed in IE/Firefox is 1 less than clamp property value.
  // https://github.com/CezaryDanielNowak/React-dotdotdot/issues/10
  return /*#__PURE__*/React.createElement(_reactDotdotdot.default, {
    clamp: clamp + 1,
    className: (0, _classnames.default)(classes.dotdotdot, className),
    tagName: "span",
    title: title
  }, children);
};
Clamp.displayName = 'Clamp';
Clamp.defaultProps = {
  clamp: 2
};
var _default = exports.default = Clamp;
//# sourceMappingURL=Clamp.js.map